var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"entity"},[_c('div',{staticClass:"entity__label"},[_vm._v(_vm._s(_vm.label)+" "),(!_vm.optional)?_c('span',[_vm._v("*")]):_vm._e()]),_c('div',{staticClass:"entity__content",on:{"click":_vm.click}},[_vm._v(_vm._s(_vm.entityLabel))])])
}
var staticRenderFns = []

export { render, staticRenderFns }